import { ApiClient } from '@webapp/core/services/ApiClient'
import { ReportExportTaskRepository } from './ReportExportTaskRepository'

export const reportExportTaskRepository = new ReportExportTaskRepository({
  httpClient: ApiClient,
})
